export default (context) => {
    context.musics = context.musics.map((item) => {
        let arr = item
        arr.play = false
        let audio = document.getElementById(`${item.id}`)
        audio.pause()
        return arr
    })
}